import * as React from "react"
import { ChevronsUpDown, Plus } from "lucide-react"

import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuShortcut,
	DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	useSidebar,
} from "@/components/ui/sidebar"

export function StoreSwitcher({
	                              stores,
                              }: {
	stores: {
		name: string
		logo: React.ElementType
		plan: string
	}[]
}) {
	const { isMobile } = useSidebar()
	const [activeStore, setActiveStore] = React.useState(stores[0])

	if (!activeStore) {
		return null
	}

	const ActiveStoreLogo = activeStore.logo

	return (
		<SidebarMenu>
			<SidebarMenuItem>
				<DropdownMenu>
					<DropdownMenuTrigger
						render={
							<SidebarMenuButton
								size="lg"
								className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
							/>
						}
					>
						<div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
							<ActiveStoreLogo className="size-4" />
						</div>

						<div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-medium">
                {activeStore.name}
              </span>
							<span className="truncate text-xs">
                {activeStore.plan}
              </span>
						</div>

						<ChevronsUpDown className="ml-auto size-4" />
					</DropdownMenuTrigger>

					<DropdownMenuContent
						className="w-(--anchor-width) min-w-56 rounded-lg"
						align="start"
						side={isMobile ? "bottom" : "right"}
						sideOffset={4}
					>
						<DropdownMenuGroup>
							<DropdownMenuLabel className="text-xs text-muted-foreground">
								Stores
							</DropdownMenuLabel>

							{stores.map((store, index) => {
								const StoreLogo = store.logo

								return (
									<DropdownMenuItem
										key={store.name}
										onClick={() => setActiveStore(store)}
										className="gap-2 p-2"
									>
										<div className="flex size-6 items-center justify-center rounded-md border">
											<StoreLogo className="size-3.5 shrink-0" />
										</div>

										<span className="flex-1 truncate">
                      {store.name}
                    </span>

										<DropdownMenuShortcut>
											⌘{index + 1}
										</DropdownMenuShortcut>
									</DropdownMenuItem>
								)
							})}
						</DropdownMenuGroup>

						<DropdownMenuSeparator />

						<DropdownMenuGroup>
							<DropdownMenuItem className="gap-2 p-2">
								<div className="flex size-6 items-center justify-center rounded-md border bg-transparent">
									<Plus className="size-4" />
								</div>

								<div className="font-medium text-muted-foreground">
									Add store
								</div>
							</DropdownMenuItem>
						</DropdownMenuGroup>
					</DropdownMenuContent>
				</DropdownMenu>
			</SidebarMenuItem>
		</SidebarMenu>
	)
}